import type { AppModule } from '@/app/app-module.types';
import { UsersIcon } from '@/shared/icons';
import {
  ADMINISTRATOR,
  CUSTOMER_SUCCESS_TEAM,
  IAM_EDITOR,
} from '@/shared/guards/roles';
import { usersContainer } from './di/container';
import { UsersRepositoryToken } from './di/tokens';
import { usersRoutes } from './presentation/routes';

/**
 * Módulo de gestão de usuários (= IdentityModule no monolith).
 * Exclusivo do admin: aparece no grupo "Gerenciamento" da sidebar.
 */
export const usersModule: AppModule = {
  name: 'users',

  register(container) {
    container.register(UsersRepositoryToken, () => usersContainer.repository);
  },

  routes: usersRoutes,

  menu: [
    {
      label: 'Usuários',
      to: '/management/users',
      icon: UsersIcon,
      section: 'registry',
      order: 1,
      // Acesso ao módulo: admin geral, customer success OU editor de acessos.
      roles: [ADMINISTRATOR, CUSTOMER_SUCCESS_TEAM, IAM_EDITOR],
    },
  ],
};
